export default {
  loadingWidgets: ({ loadingWidgets }) => loadingWidgets,
};
